import React, { useCallback, useMemo } from 'react';
import DocumentPaperLetter, { letter } from '../DocumentPaperLetter';
import Logo from './../../../assets/static/logo-horizontal.svg';
import Parse from 'parse';
import _ from 'underscore';
import GroupTables from './components/GroupTables';
import Summary from './components/Summary';
import {
  agruparBidimensional,
  excludeFirst,
  setGroupTablesByNumber,
  setNumbersPayments,
  setPaymentDays,
} from './utils';
import IndividualCreditTables from './components/IndividualCreditTables';
import ContainerTables from './components/ContainerTables';

const styles = {
  docSection: { paddingTop: 0, paddingBottom: 0 },
  fontSize: { fontSize: '7pt' },
  title: {
    fontSize: '2rem',
    fontWeight: '500',
    lineHeight: 1.2,
    margin: 0,
  },
  contentTables: { paddingTop: '3rem', paddingBottom: '3rem' },
};

const SUBGROUPS_LARGE = 2;
const SUBGROUPS_INDIVIDUAL = 4;

const DocumentPaymentControl = () => {
  const requisition = JSON.parse(localStorage.getItem('requisition'));
  const user = Parse.User.current();
  const isBigGroup = requisition?.Grupo?.Socios?.length >= 8;
  const isIndividualCredit = requisition?.Grupo?.Socios?.length === 1;
  let fecha = false;

  if (requisition?.fecha_elaboracion) {
    fecha = new Date(requisition.fecha_elaboracion.iso);
    fecha.setHours(0, 0, 0, 0);
    fecha = fecha.getTime();
  }

  const groupDataFn = useCallback(
    (arr) => {
      if (isBigGroup) {
        return [arr[0], ...agruparBidimensional(arr.slice(1), SUBGROUPS_LARGE)];
      }
      if (isIndividualCredit) {
        const first = arr.slice(0, SUBGROUPS_INDIVIDUAL);
        const rest = agruparBidimensional(
          arr.slice(SUBGROUPS_INDIVIDUAL),
          SUBGROUPS_INDIVIDUAL
        );
        return [first, ...rest];
      }
      return arr;
    },
    [isBigGroup, isIndividualCredit]
  );

  const groupTables = useMemo(
    () => groupDataFn(setGroupTablesByNumber(requisition, 1)),
    [requisition, groupDataFn]
  );

  const numbersPayments = useMemo(
    () => groupDataFn(setNumbersPayments(requisition, 1)),
    [requisition, groupDataFn]
  );

  const paymentDays = useMemo(
    () => groupDataFn(setPaymentDays(requisition, fecha, 1)),
    [requisition, fecha, groupDataFn]
  );

  if (!user) {
    window.location.href = '/';
    return null;
  }

  if (_.isEmpty(requisition)) return null;

  return (
    <div className="d-flex flex-column align-items-center justify-content-center">
      <DocumentPaperLetter style={{ ...styles.fontSize, ...styles.docSection }}>
        <div
          style={{
            ...styles.fontSize,
            height: `${letter.HEIGHT / 2}cm`,
            gap: '1rem',
          }}
          className="d-flex flex-column justify-content-center w-100"
        >
          <div className="text-center">
            <img
              src={Logo}
              alt="SOLFIN DEL SURESTE | confía en tú palabra"
              width="380"
            />
          </div>

          <div>
            <h2 className="text-primary text-center" style={styles.title}>
              CONTROL DE PAGOS
            </h2>
          </div>

          <Summary requisition={requisition} fecha={fecha} />
        </div>

        {isBigGroup ? (
          <GroupTables
            groupData={[groupTables[0][0]]}
            numbersPayments={[numbersPayments[0][0]]}
            paymentDays={[paymentDays[0][0]]}
            promotor={requisition.promotor}
            fecha={fecha}
            requisition={requisition}
            letter={letter}
          />
        ) : isIndividualCredit ? (
          <ContainerTables isIndividual>
            {groupTables[0].map((amounts, idx) => (
              <GroupTables
                key={idx}
                groupData={amounts}
                numbersPayments={numbersPayments[0][idx]}
                paymentDays={paymentDays[0][idx]}
                promotor={requisition.promotor}
                fecha={fecha}
                requisition={requisition}
                letter={letter}
              />
            ))}
          </ContainerTables>
        ) : (
          groupTables.map((amounts, idx) => (
            <GroupTables
              key={idx}
              groupData={amounts}
              numbersPayments={numbersPayments[idx]}
              paymentDays={paymentDays[idx]}
              promotor={requisition.promotor}
              fecha={fecha}
              requisition={requisition}
              letter={letter}
            />
          ))
        )}
      </DocumentPaperLetter>

      {isBigGroup &&
        excludeFirst(groupTables)?.map((groupTable, idxGroup) => (
          <DocumentPaperLetter
            key={idxGroup}
            style={{ ...styles.fontSize, ...styles.docSection }}
          >
            <ContainerTables>
              {groupTable.map((amounts, idxAmounts) => (
                <GroupTables
                  key={idxAmounts}
                  groupData={amounts}
                  numbersPayments={numbersPayments[idxGroup + 1][idxAmounts]}
                  paymentDays={paymentDays[idxGroup + 1][idxAmounts]}
                  promotor={requisition.promotor}
                  fecha={fecha}
                  requisition={requisition}
                  letter={letter}
                />
              ))}
            </ContainerTables>
          </DocumentPaperLetter>
        ))}

      {isIndividualCredit && (
        <IndividualCreditTables
          groupTables={groupTables}
          numbersPayments={numbersPayments}
          paymentDays={paymentDays}
          requisition={requisition}
          fecha={fecha}
        />
      )}
    </div>
  );
};

export default DocumentPaymentControl;
